import { createUseStyles } from 'react-jss';

export default createUseStyles({
  uploadingIconWrapper: {
    fontSize: '36px',
    marginLeft: '12px',
    '@media(max-width: 900px)': {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '12px',
    },
  },
});
